import axiosClient from './axiosClient';

export const isoStandardsService = {
  list: () => axiosClient.get('/iso-standards'),
  get: (id) => axiosClient.get(`/iso-standards/${id}`),
  getClauses: (standardId) => axiosClient.get(`/iso-standards/${standardId}/clauses`),
  getClause: (clauseId) => axiosClient.get(`/iso-standards/clauses/${clauseId}`),
  getPurchased: () => axiosClient.get('/iso-standards/purchased'),
};

export const getAllISOStandardsPublic = () =>
  axiosClient.get('/iso-standards/public');
